module.exports = __webpack_public_path__ + "static/img/PolicyDirectAccess.ba18b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/PolicyDirectAccess.png
// module id = n5aB
// module chunks = 44